import {Component, EventEmitter, Output, OnInit} from '@angular/core';
import {TranslationSelectorService} from '@xref/ngx';
import { SettingsMenuService } from '../../services/settings-menu/settings-menu.service';
import {faTimesCircle} from '@fortawesome/free-solid-svg-icons';
import { BackdropService } from 'src/app/services/backdrop/backdrop.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import * as Cookies from 'js-cookie';
import Constants from '../../shared/constants';

@Component({
    selector: 'xqnr-settings-menu',
    templateUrl: './settings-menu.component.pug',
    styleUrls: ['./settings-menu.component.scss'],
    standalone: false
})
export class SettingsMenuComponent implements OnInit {
  @Output() themeChange = new EventEmitter();
  showMenu: boolean;
  checked = false;
  loaded = false;

  loggedIn = false;

  icons = {
    faTimesCircle
  };


  constructor(
    private translationSelector: TranslationSelectorService,
    public settingsMenu: SettingsMenuService,
    private backdrop: BackdropService,
    private auth: AuthService
  ) {}

  ngOnInit() {
    this.translationSelector.mockLocaleData();
    this.isLoaded();
    this.showContrastMode();

    // this.translationSelector.getI18nHelperLocaleData().then(this.isLoaded);

    this.backdrop.active$.subscribe((activeState: boolean) => {
      if (!activeState) this.settingsMenu.hide();
    });

    // Watch for user logged in status
    this.auth.loggedIn$.subscribe((loggedIn: boolean) => {
      this.loggedIn = loggedIn;
    });
  }

  showContrastMode() {
    this.checked = Cookies.get(Constants.CONTRAST) === 'true';
  }

  isLoaded = () => {
    if (this.translationSelector.hasData())
      this.loaded = true;
  };

  checkedChange() {
    this.themeChange.emit(this.checked);
  }

  logout() {
    this.settingsMenu.hide();
    this.backdrop.hide();
    this.auth.logout();
  }
}
